<template>
  <div>
    <div class="container" v-if="loading">
      <div class="row waiting">
        <div class="col align-self-center text-center ">
            <square-loader />
        </div>
      </div>
    </div>
    <div class="container d-flex flex-column">
      <Logged-user />
      <div class="row">
        <div class="col-12 text-center head">
          <img src="../assets/logoLCT-2.gif"/>
          <h1>Bienvenue sur le Scrabble Lettre Compte Triple</h1>
        </div>
      </div>
      <div class="row">
        <div class="col-12 text-center mt-4 mb-4">
          Vous pouvez jouer ici au Scrabble duplicate
          à plusieurs depuis votre mobile ou votre ordinateur.
        </div>
      </div>
      <div class="row mt-4" v-if="isConnected">
        <div class="col-12 offset-lg-4 col-lg-4 offset-md-2 col-md-8">
          <div class="social-button" @click="goLobby()">
            <div class="d-flex justify-content-center">
              <div><img src="/static/coffee.svg" height="20"/></div>
              <div>Rejoindre le salon</div>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-4" v-else>
        <div class="col-12 offset-lg-4 col-lg-4 offset-md-2 col-md-8">
          <div class="social-button" @click="authenticateCognito()">
            <div class="d-flex justify-content-center">
              <div><img src="/static/g.svg" height="20"/></div>
              <div>Commencer (connexion Google)</div>
            </div>
          </div>
          <div class="social-button mt-4" @click="authenticateCognitoFacebook()">
            <div class="d-flex justify-content-center">
              <div><img src="/static/f.svg" height="20"/></div>
              <div>Commencer (connexion Facebook)</div>
            </div>
          </div>
          <div class="btn btn-link mt-4" @click="otherAuth()">
            Je veux me connecter avec identifiant / mot de passe...
          </div>
          <div class="mt-4text-justify">
            <small>
            Afin de freiner les utilisateurs malveillants,
            Lettre Compte Triple utilise désormais vos comptes Google ou
            Facebook pour vous identifier.
            Lettre Compte Triple prend soin de vos données.
            Elles ne servent qu'à sauvegarder vos scores et suivre votre progression.
            </small>
          </div>
        </div>
      </div>
      <!-- lct-org home  annonce google -->
      <div class="row mt-4" v-if="!premium">
        <div class="col-12 text-center">
          <adsense
              ad-style="display:block"
              ad-client="ca-pub-1546035667994677"
              ad-slot="1338344973"
              ad-format="auto"></adsense>
        </div>
      </div>
      <Articles />
      <div class="row mt-4 mb-4">
        <div class="col-12 col-md-8 offset-md-2 col-lg-6 offset-lg-3">
          <img src="/static/i_new_decade.svg" width="100%"/>
        </div>
      </div>
      <div class="mt-auto">
        <bottom-nav />
      </div>
    </div>
  </div>
</template>

<script>
import LoggedUser from './LoggedUser';
import BottomNav from './BottomNav';
import Articles from './Articles';
import adsense from './VueAdsense';
import SquareLoader from './SquareLoader';
import iam from '../iam';

export default {
  name: 'Home',
  components: { LoggedUser, BottomNav, Articles, SquareLoader, adsense },
  data() {
    return {
      isConnected: iam.getConnectedUser(),
      premium: iam.isPremium(),
      loading: true,
    };
  },
  created() {
    const authorizationCode = this.$route.fullPath.match(/(?:code)=([^&]+)/) ? this.$route.fullPath.match(/(?:code)=([^&]+)/)[1] : undefined;
    if (authorizationCode) {
      iam.tokenCognito(authorizationCode)
        .then(() => this.$http.get(`${process.env.LCT_API_URL}/users/me`))
        .then(response => response.data)
        .then((user) => {
          if (user.username) {
            iam.setConnectedUser(user);
            this.$router.push('/lobby');
          } else {
            this.$router.push('/username');
          }
        })
        .catch((err) => {
          this.error = err;
          iam.logout();
          this.isConnected = false;
          this.premium = false;
          this.loading = false;
        });
    } else {
      this.loading = false;
    }
  },
  methods: {
    authenticateCognito() {
      iam.authorizationCognito('Google');
    },
    authenticateCognitoFacebook() {
      iam.authorizationCognito('Facebook');
    },
    otherAuth() {
      iam.authenticateCognito();
    },
    goLobby() {
      this.$router.push('Lobby');
    },
  },
};
</script>

<style scoped>
div.waiting {
  min-height: 100vh;
}
.head {
  margin-top: 4rem;
}
.big-picture {
  margin-top: 4rem;
  margin-bottom: 4rem;
}
.head img{
  max-width: 100%;
  margin-bottom: 2rem;
}
.social-button {
  line-height: 30px;
  color: #757575;
  -webkit-border-radius: 1px;
  -moz-border-radius: 1px;
  border-radius: 1px;
  padding: 8px;
  -webkit-box-shadow: 0 2px 4px 0px rgba(0,0,0,.25);
  box-shadow: 0 2px 4px 0 rgba(0,0,0,.25);
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  -webkit-transition: background-color .218s, border-color .218s, box-shadow .218s;
  transition: background-color .218s, border-color .218s, box-shadow .218s;
  -webkit-user-select: none;
  -webkit-appearance: none;
  font-family: Roboto,arial,sans-serif;
  font-weight: 500;
  letter-spacing: .21px;
  font-size: 0.9rem;
}
.social-button:hover {
  -webkit-box-shadow: 0 0 3px 3px rgba(66,133,244,.3);
  box-shadow: 0 0 3px 3px rgba(66,133,244,.3);
  cursor: pointer;
}
.social-button div div {
  padding: 0 6px;
}
.letter p {
  line-height: 2rem;
}
.tile{
  background-color: #d9c28d;
  font-weight: bold;
  font-family: arial;
  position: relative;
  text-align: center;
  font-size: 0.8rem;
  border: 1px solid #b7b3b3;
}
.tile .points{
  position: absolute;
  right: 0;
  bottom: 0;
  font-size: 0.5rem;
  line-height: 0.5rem;
}
.grey {
  background-color: #e4e0e0;
}
.blue {
  background-color: #E8FFF4;
}
.btn-link {
  font-size: 0.8rem;
  text-decoration: underline;
}
.btn-link:hover {
  cursor: pointer;
}
.big-marging{
  margin-top: 100px;
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue